module.exports = __webpack_public_path__ + "static/media/linkedin_share.6689025e.svg";